module.exports = __webpack_public_path__ + "static/media/codeucate_logo.cd3be30c.png";